import { apiCall } from "./Interceptor";

const GET_ALL_CAPACITY_GEN = "/generator/capacity/getAll";
const GET_ALL_CAPACITY_CONSUMER = "/consumer/capacity/getAll";

const getAllGeneratorCapacity = async (data) => {
    const response = await apiCall.post(GET_ALL_CAPACITY_GEN,data);
    return response;
}
const getAllConsumerCapacity = async (data) => {
    const response = await apiCall.post(GET_ALL_CAPACITY_CONSUMER,data);
    return response;
}
export default {
    getAllGeneratorCapacity,
    getAllConsumerCapacity,
};
